export const Flashable = (message, className, state = true) => {
  let flashHash = { message: message, className: className };

  if (state) {
    flashHash = { flash: flashHash };
  }

  return flashHash;
};
